import { Injectable, inject } from '@angular/core';
import { catchError } from 'rxjs/operators';

import { RestapiService } from '@app/services/restapi.service';
import { NonPmsModelModel } from '@shared/interfaces/turnover.interface';
import { SnackbarErrorMessage } from '@ui-components/components/customized-snackbar/snackbar-message.enum';
import { SnackbarService } from '@ui-components/components/customized-snackbar/snackbar.service';

@Injectable({ providedIn: 'root' })
export class UnitNonPmsService {
  private restApiService: RestapiService = inject(RestapiService);
  private snackbarService: SnackbarService = inject(SnackbarService);

  add(data: NonPmsModelModel) {
    return this.restApiService.create<number>(`Units/nonPms`, data).pipe(
      catchError(err => {
        const errorMsg = this.snackbarService.getErrorCodeMsg(err) ?? SnackbarErrorMessage.SomethingWentWrong;
        this.snackbarService.error(errorMsg);
        throw err;
      })
    );
  }

  update(data: NonPmsModelModel) {
    return this.restApiService.update<NonPmsModelModel>(`Units/nonPms`, data).pipe(
      catchError(err => {
        const errorMsg = this.snackbarService.getErrorCodeMsg(err) ?? SnackbarErrorMessage.SomethingWentWrong;
        this.snackbarService.error(errorMsg);
        throw err;
      })
    );
  }

  delete(id: number) {
    return this.restApiService.delete<NonPmsModelModel>(`Units/nonPms/${id}`).pipe(
      catchError(err => {
        const errorMsg = this.snackbarService.getErrorCodeMsg(err) ?? SnackbarErrorMessage.SomethingWentWrong;
        this.snackbarService.error(errorMsg);
        throw err;
      })
    );
  }
}
